/* 产品列表 tabel */
<template>
  <div class="product-item">
    <div
      v-if="(detail && detail.lists) || (lists && lists.length > 0)"
      v-for="(item, k) in detail.lists || lists"
      :key="k"
      class="pro-products-data"
      :class="detail && detail.detail.valid === 2 ? 'disabled' : ''"
    >
      <Table
        :columns="columns"
        :data="
          detail && detail.lists && detail.lists.length > 0
            ? item.itemAreaList.length > 0 && item.itemAreaList
            : item.itemAreaList
        "
        disabled-hover
        class="render-extend-style"
        :class="k === 0 ? '' : 'tabel-null-header'"
        tooltip
      >
        <template slot-scope="{ row, index }" slot="classification">
          <div>
            <Row type="flex" justify="space-between" lign="middle">
              <Col v-if="index === 0" class="classification_name">{{
                item.area
              }}</Col>
              <Col v-else class="classification_name"></Col>
              <Col>
                <span class="classification_num">{{ row.activeIndex }}</span>
              </Col>
            </Row>
          </div>
        </template>
        <template slot-scope="{ row }" slot="name">
          <Row :gutter="10" type="flex" justify="center" align="middle">
            <Col span="9">
              <z-panelimg
                v-if="detail && detail.detail"
                :disabled="disabledShow(row.product)"
                :del="false"
                :choice="row.product.specs && row.product.specs[0].stockStatus===1"
                :newProduct="row.newPlus===1"
                :src="ossPrefix + coverImg(row.product)"
              ></z-panelimg>
              <z-panelimg
                v-else
                :del="false"
                :choice="row.product.specs && row.product.specs[0].stockStatus===1"
                :newProduct="row.newPlus===1"
                :src="ossPrefix + coverImg(row.product)"
              ></z-panelimg>
            </Col>
            <Col span="15">
              <p class="pro-products-data-name">{{ row.product.name }}</p>
              <p class="pro-products-data-code">{{ row.product.code }}</p>
            </Col>
          </Row>
        </template>
        <template slot-scope="{ row, index }" slot="remark">
          <div>{{ row.product.remark || "暂无" }}</div>
        </template>
        <template slot-scope="{ row }" slot="num">
          <div>{{ row.num }}</div>
        </template>
        <template slot-scope="{ row }" slot="price">
          <div v-if="detail && detail.detail">
            <span v-if="detail.detail.valid === 2" class="enquiruing"
              >报价失效</span
            >
            <span
              v-if="
                detail.detail.valid !== 2 &&
                  detail.detail.status !== 3 &&
                  row.status === 2
              "
              >{{ row.price | currency("¥", "2") }}</span
            >
            <span
              v-if="
                detail.detail.valid !== 2 &&
                  detail.detail.status !== 3 &&
                  row.status === 1
              "
              class="enquiruing"
              >报价中</span
            >
            <span v-if="detail.detail.valid !== 2 && detail.detail.status === 3"
              >--</span
            >
            <Tooltip
              placement="left"
              :content="row.rejectReason"
              theme="light"
              max-width="400"
            >
              <span
                v-if="
                  detail.detail.valid !== 2 &&
                    detail.detail.status !== 3 &&
                    row.status === 3
                "
                class="enquiruing"
                >报价失败</span
              >
            </Tooltip>
          </div>
          <div v-else>
            <span>{{ row.price | currency("¥", "2") }}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="total">
          <div v-if="detail && detail.detail">
            <span v-if="detail.detail.valid === 2" class="enquiruing"
              >报价失效</span
            >
            <span
              v-if="detail.detail.valid !== 2 && row.status === 2 && row.price"
              >{{ (row.price * row.num) | currency("¥", "2") }}</span
            >
            <span
              v-if="
                detail.detail.valid !== 2 &&
                  detail.detail.status !== 3 &&
                  row.status === 1
              "
              class="enquiruing"
              >报价中</span
            >
            <span v-if="detail.detail.valid !== 2 && detail.detail.status === 3"
              >--</span
            >
            <span
              v-if="
                detail.detail.valid !== 2 &&
                  detail.detail.status !== 3 &&
                  row.status === 3
              "
              >报价失败</span
            >
          </div>
          <div v-else>
            <span v-if="row.price">{{
              (row.price * row.num) | currency("¥", "2")
            }}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template
          v-if="!detail || !detail.detail"
          slot-scope="row"
          slot="operating"
        >
          <router-link
            v-if="row.row.modifyStatus === 1"
            :to="`/modify-item-record/${$route.params.id}/${row.row.id}`"
          >
            <Button size="small">查看详情</Button>
          </router-link>
          <span v-else>--</span>
        </template>
      </Table>

      <!-- 补充说明 -->
      <div
        class="added-detail"
        v-if="
          k + 1 === ((detail.lists && detail.lists.length) || lists.length) &&
            detail.detail &&
            detail.detail.status === 2 &&
            detail.detail.quotedNum > 0 &&
            detail.detail.projectAdditionalDesc
        "
      >
        <div class="insert">
          <p class="title">项目补充说明</p>
          <div class="main">{{ detail.detail.projectAdditionalDesc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Products from "@/mixins/Products";
import tabelExpandMaterial from "./table-expand-material.vue";
export default {
  mixins: [Products],
  data() {
    return {
      columns: [
        {
          title: "空间",
          align: "center",
          slot: "classification",
          width: 120
        },
        {
          type: "expand",
          width: 1,
          render: (h, params) => {
            return h(tabelExpandMaterial, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: "产品",
          align: "center",
          slot: "name",
          width: 200
        },
        {
          title: "定制要求",
          align: "center",
          slot: "remark"
        },
        {
          title: "数量",
          align: "center",
          slot: "num"
        },
        {
          title: "落地参考价",
          align: "center",
          slot: "price",
          width: 150
        },
        {
          title: "小计",
          align: "center",
          slot: "total",
          width: 150
        },
        {
          title: "修改记录",
          align: "center",
          slot: "operating",
          width: 150
        }
      ]
    };
  },
  components: { tabelExpandMaterial },
  props: {
    detail: {
      type: [Object, String],
      default: ""
    },
    lists: {
      type: [Array, String],
      default: ""
    }
  },
  methods: {
    setObjectParams(lists) {
      if (!lists || lists.length === 0) return false;
      let _acIndex = 0;
      lists.forEach(item => {
        item.itemAreaList &&
          item.itemAreaList.length > 0 &&
          item.itemAreaList.forEach(element => {
            _acIndex += 1;
            this.$set(element, "activeIndex", _acIndex);
            this.$set(element, "_expanded", true);
          });
      });
    }
  },
  created() {
    if (this.lists && this.lists.length > 0) {
      this.setObjectParams(this.lists);
    }else {
      this.columns.pop();
    }
  },
  watch: {
    "detail.lists": function() {
      this.setObjectParams(this.detail.lists);
    },
    lists: function() {
      this.setObjectParams(this.lists);
    }
  }
};
</script>

<style lang="scss">
.product-item {
  margin: 20px 0;
  td.ivu-table-column-center {
    background: #fff !important;
  }
  .ivu-table-tbody tr.ivu-table-row {
    &:first-child {
      td.ivu-table-column-center {
        border: none !important;
      }
    }
  }
  .ivu-table:before {
    background-color: #ececec;
  }
  .ivu-table th {
    height: 50px;
  }
  thead tr th.ivu-table-column-center .ivu-table-cell {
    span {
      font-size: 14px;
      color: #21201f;
      font-weight: 400;
    }
  }
  .classification_name {
    font-weight: 500;
    max-width: 55px;
  }
  .classification_num {
    display: inline-block;
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 23px;
    border-radius: 50%;
    border: 1px solid #979797;
  }
}
</style>
